import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public static default = 'modified-bootstrap';
  private readonly style: HTMLLinkElement;

  constructor() {
    this.style = document.createElement('link');
    this.style.rel = 'stylesheet';
    document.head.appendChild(this.style);

    this.initTheme();
  }

  /**
   * Gets the current theme from the local storage if set, else return the default theme
   *
   * @return current theme as a string
   */
  public get current(): string {
    return localStorage.getItem('theme') ?? ThemeService.default;
  }

  /**
   * Sets current theme in the local storage and updates the stylesheet link element
   *
   * @param value Name of the theme to set
   */
  public set current(value: string) {
    localStorage.setItem('theme', value);
    this.style.href = `/${value}.scss`;
  }

  /**
   * Initializes the theme by checking the local storage and setting the theme if it exists.
   * If no theme can be found in the local storage the default theme is used instead
   */
  private async initTheme(): Promise<void> {
    if (localStorage.getItem('theme') !== undefined) {
      await this.setTheme(this.current);
      console.log("Set Theme to " + this.current);
    }
  }

  /**
   * Sets the theme by updating the href of the link element to the corresponding theme file.
   *
   * @param theme Name of the theme to set
   */
  private async setTheme(theme: string): Promise<void> {
    const themeFile = theme === ThemeService.default ?
      `/assets/theme/${theme}.scss` :
      `/${theme}.scss`;

    try {
      const response = await fetch(themeFile, { method: 'HEAD' });
      if (response.ok) {
        this.style.href = themeFile;
      } else {
        console.error(`Theme file not found: ${themeFile}`);
      }
    } catch (error) {
      console.error(`Error checking theme file: ${themeFile}`, error);
    }
  }
}
